export default __webpack_public_path__ + "static/media/donut-bronze.8c867a10.png";